export default __webpack_public_path__ + "static/5-8a45e01c16f45d130370e6d311f67b71.jpeg";